module.exports = __webpack_public_path__ + "static/media/Sharp-LQ121K1LG58-Mechanical-Drawing-clean.160d4b1d.png";